const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarGarage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607D8B"
    },
    d: "M 24 6 L 2 17.890625 L 2 42 L 46 42 L 46 17.890625 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E2723"
    },
    d: "M 13 36 C 13 35.445313 12.554688 35 12 35 L 9 35 C 8.445313 35 8 35.445313 8 36 L 8 41 C 8 41.554688 8.445313 42 9 42 L 12 42 C 12.554688 42 13 41.554688 13 41 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E2723"
    },
    d: "M 40 36 C 40 35.445313 39.554688 35 39 35 L 36 35 C 35.445313 35 35 35.445313 35 36 L 35 41 C 35 41.554688 35.445313 42 36 42 L 39 42 C 39.554688 42 40 41.554688 40 41 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEB3B"
    },
    d: "M 40 30 C 40 29.445313 39.554688 29 39 29 L 9 29 C 8.445313 29 8 29.445313 8 30 L 8 38 C 8 38.554688 8.445313 39 9 39 L 39 39 C 39.554688 39 40 38.554688 40 38 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEB3B"
    },
    d: "M 39 39 L 9 39 C 8 37 8 30 8 30 C 8 28.894531 8.894531 28 10 28 L 24 27 L 38 28 C 39.105469 28 40 28.894531 40 30 C 40 30 40 37 39 39 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEB3B"
    },
    d: "M 41 26 L 37.109375 26 C 35.816406 23.9375 34.28125 21.488281 34 21 C 33.441406 20.027344 32.347656 20 32.046875 20 C 32.027344 20 32.011719 20 32 20 C 32 20 28 20 24 20 C 20.082031 20 16.160156 20 16 20 C 15.671875 20 14.640625 20 14 21 C 13.644531 21.558594 12.136719 23.96875 10.871094 26 L 7 26 C 6.445313 26 6 26.445313 6 27 L 6 29 C 6 29.554688 6.445313 30 7 30 L 41 30 C 41.554688 30 42 29.554688 42 29 L 42 27 C 42 26.445313 41.554688 26 41 26 Z M 15.683594 22.078125 C 15.714844 22.03125 15.734375 22 16 22 L 32.046875 22 C 32.175781 22 32.25 22.019531 32.285156 22.027344 C 32.679688 22.707031 34.636719 25.824219 36 27.988281 L 36 28 L 12 28 L 12 27.96875 C 13.339844 25.820313 15.277344 22.710938 15.683594 22.078125 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 38 34 C 38 34.554688 37.554688 35 37 35 L 11 35 C 10.445313 35 10 34.554688 10 34 L 10 31 C 10 30.445313 10.445313 30 11 30 L 37 30 C 37.554688 30 38 30.445313 38 31 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4DD0E1"
    },
    d: "M 14 32.5 C 14 33.328125 13.328125 34 12.5 34 C 11.671875 34 11 33.328125 11 32.5 C 11 31.671875 11.671875 31 12.5 31 C 13.328125 31 14 31.671875 14 32.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4DD0E1"
    },
    d: "M 37 32.5 C 37 33.328125 36.328125 34 35.5 34 C 34.671875 34 34 33.328125 34 32.5 C 34 31.671875 34.671875 31 35.5 31 C 36.328125 31 37 31.671875 37 32.5 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarGarage);
export default __webpack_public_path__ + "static/media/car-garage.58866a32030082073115396f29290d1d.svg";
export { ForwardRef as ReactComponent };